import React from "react"
import Typography from '@mui/material/Typography';
//import ArrowRightIcon from '@mui/icons-material/ArrowRight';

export const TextDisease = () => {

return(
<div>
    
<Typography variant="h6" >
<br />

Coronary heart disease and diabetes are highly interrelated and complex diseases.
<br /><br /> 
Coronary Artery Diseases (CADs) are the leading cause of death worldwide, and are partly heritable. 
CADs are in contrast to  monogenic cardiovascular diseases such as inherited cardiomyopathies, rhythm disorders, and vascular disorders, for which rare DNA variants with large effects are responsible.
Complex diseases are influenced by common and rare DNA variants at numerous loci distributed throughout the genome
<br /> <br /> 


<Typography component="span" variant="h5" sx={{fontWeight: '600'}}>Associated Genes: </Typography>
<br /><br />
- hypertrophic_cardiomyopathy = ['MYH7', 'MYBPC3', 'TNNT2', 'TPM1', 'MYL2', 'MYL3', 'PLN', 'MYBPC3', 'TNNI3']    <br /> 
- arrhythmogenic_right_ventricular_cardiomyopathy = ['PKP2', 'DSP', 'DSG2', 'JUP', 'TMEM43']<br /> 
- familial_dilated_cardiomyopathy = ['MYH7', 'MYBPC3', 'TNNT2', 'MYH6', 'MYPN', 'ANKRD1', 'RAF1', 'DES', 'DMD']<br /> 
- marfans_syndrome = ['FBN1', 'TGFBR1', 'TGFBR2', 'SMAD3', 'TGFB2', 'TGFB3', 'SKI']<br /> 
- thoracic_aortic_aneurysm_and_dissection = ['ACTA2', 'FBN1', 'MYH11', 'TGFBR1', 'TGFBR2' , 'LOX', 'COL3A1', 'TGFB2', 'TGFB3']<br /> 
- long_QT_syndrome = ['KCNQ1', 'KCNH2', 'KCNE1', 'KCNJ2', 'SCN5A', 'CAV3', 'CALM1', 'CALM2']<br /> 
- short_QT_syndrome = ['KCNH2']<br /> 
- brugada_syndrome = ['SCN5A']<br /> 
- risk_myocardial_infarction = ['ANRIL']<br /> 
- smoking_addiction = ['CHRNA5', 'CHRNA3', 'CHRNB4'] <br /> <br /> <br /> 
- coronary_artery:  <br /><br /> 
'LDLR', 'PCSK9', 'NPC1L1', 'APOB', 'GUCY1A3', 'LPA', 'LPL', 'APOA5', 'APOC3', 'ANGPTL4', 'ASGR1', 'CPT1A', 'SLC16A11', 'ANRIL', 'CDKN2A', 'CDKN2B', 'MTAP', 'IFNA21', 'SORT1', 'PSRC1', 'CELSR2', 
'PHACTR1', 'EDN1', 'ADAMTS7', 'ANGPTL3', 'TNNT2', 'KCNQ1', 'APOE', 'HMGCR', 'LIPG', 'ABCA1', 'APOC3', 'ANGPTL3', 'TRIB1' 


<br /><br /> 
 
</Typography>

</div>
)
}